<template>
<div class="patienttray">
    <div class="vx-row">
        <vx-card>
            <div class="vx-row">
                <div class="vx-col w-full md:w-1/2">
                    <div class="vx-row">
                        <div class="vx-col" style="padding-right:9px;">
                            <!-- <vs-avatar icon-pack="feather" icon="icon-user" size="60px"/> -->
                            <!-- <UserIcon class="inline-flex rounded-full" style="height:50px;width:50px;"></UserIcon> -->
                            <vs-avatar size="50px" />
                        </div>
                        <div class="vx-col" style="margin-top:2%;padding-left:9px;">
                            <h5>{{patientName}}</h5>
                            <h6 class="detText">
                                <span>{{gender}}</span>&nbsp;.&nbsp;
                                <span>{{age}}</span>&nbsp;.&nbsp;
                                <span>{{place}}</span>
                            </h6>
                         <h6 class="detText" style="margin-top: 4px; display: flex; align-items: center; gap: 10px;">
                        <span style="display: flex; align-items: center; gap: 4px;">
                            <PhoneIcon style="width:14px; height:14px;" />
                            <span style="font-size:12px;">{{phoneNo}}</span>
                        </span>
                        <span style="display: flex; align-items: center; gap: 4px;">
                            <MailIcon style="width:14px; height:14px;" />
                            <span style="font-size:12px;">{{email}}</span>
                        </span>
                        </h6>


                        </div>
                    </div>
                </div>

                <div class="vx-col w-full md:w-1/2">
                    <div style="display: flex; justify-content: flex-end; align-items: center; gap: 12px; padding-right: 2%;">
                        <router-link :to="{path:'/patientRegistration', query:{ patientId:patientId}}">
                  <EditIcon class="custom-class testTable" style="width:16px;color:#009696;cursor: pointer;"></EditIcon>
                        </router-link>
                    <feather-icon icon="XIcon" class="custom-class" style="width:16px;color:#009696; cursor: pointer;" title="Close" @click="exit" />                                   
     
                    </div>
                </div>
            </div>
        </vx-card>
    </div>

    <div class="vx-row mt-2">
        <vx-card>
            <div class="vx-row">
                <div class="vx-col" style="margin-left:1%;">
                    <div class="day__slot">
                        <span>

                            <router-link :to="{path:'/opTicket', query:{ patientId:patientId}}" style="color:#009696;">
                                <ClipboardIcon class="custom-class"></ClipboardIcon>
                                <p>OP</p>
                            </router-link>

                        </span>
                    </div>
                </div>


                <div class="vx-col">
                    <div class="day__slot">
                        <router-link :to="{path:'/ipDetails',query:{patientId:patientId}}" style="color:#009696;"> <span>
                                <FilePlusIcon class="custom-class"></FilePlusIcon>
                                <p>IP</p>
                            </span></router-link>
                    </div>
                </div>
                <div class="vx-col">
                    <div class="day__slot">
                        <span>

                            <router-link :to="{path:'/billing', query:{ patientId:patientId}}" style="color:#009696;">
                                <FileTextIcon class="custom-class"></FileTextIcon>
                                <p>Billing</p>
                            </router-link>
                        </span>

                    </div>
                </div>
                <div class="vx-col">
                    <div class="day__slot">
                        <span>
                            <router-link :to="{path:'/labResults', query:{ patientId:patientId}}" style="color:#009696;">
                                <PlusSquareIcon class="custom-class"></PlusSquareIcon>
                                <p>Lab</p>
                            </router-link>
                        </span>
                    </div>
                </div>
                <div class="vx-col">
                    <div class="day__slot">
                        <span>

                            <router-link :to="{path:'/billDues', query:{ patientId:patientId}}" style="color:#009696;">
                                <FileTextIcon class="custom-class"></FileTextIcon>
                                <p>Dues</p>
                            </router-link>

                        </span>
                    </div>

                </div>
            </div>
        </vx-card>
    </div>

    <div class="vx-row mt-2">
        <vx-card>
            <div class="vx-row">

                <vs-tabs style="margin-left:2%;">
                    <vs-tab label="MedicalHistory" icon-pack="feather" icon="icon-file-text">
                        <div class="tab-text">
                                <table class="detailsTable  billsTable">
                                <thead>
                                    <tr>
                                    <th class="smallhead" style="width:18%">OP Number</th>
                                    <th class="smallhead" style="width:20%;">OP Date</th>
                                    <th class="smallhead" style="width:20%;">Consulting Doctor</th>
                                    <th class="smallhead" style="width:25%;"></th>
                                   
                                    </tr>
                                </thead>
                                   <tbody>
                                <tr v-for="(item,index) in Medicallist" :key="index" @dblclick="navigateToOp(item.opNo)">
                                <td class="mediumhead" style="width:18%;">{{item.opNo}}</td>
                                <td class="mediumhead" style="width:20%;">{{formatDate(item.date)}}</td>
                                <td class="mediumhead" style="width:20%;">{{item.doctor}}</td>
                                <td class="mediumhead" style="width:25%;">
                                <span>
                                    <FileTextIcon
                                    @click.stop="navigateToPrescription(item.opNo, item.typeId)"
                                    
                                    style="color:#009696; cursor:pointer"
                                    />
                                </span>
                                </td>
                                                
                                    </tr>
                                </tbody>
                                </table>
                            <!--<div v-for="(item,index) in Medicallist" v-bind:key="index" style="cursor:pointer">
                                <table class="detailsTable">
                                    <tr @dblclick="navigateToOp(item.opNo)">
                                        <td class="detailsTd" style="color: #1d1f20;font-size: initial;font-weight: bold;width:20%">
                                            <p class="bighead">{{item.typeName}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:15%;line-height:0.5">
                                            <p class="smallhead">OPNumber</p>
                                            <p class="mediumhead">{{item.opNo}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:15%;line-height:0.5">
                                            <p class="smallhead">OP Date</p>
                                            <p class="mediumhead">{{item.date}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:50%;line-height:0.5">
                                            <p class="smallhead">Consulting Doctor</p>
                                            <p class="mediumhead">{{item.doctor}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:40%">
                                            <span>
                                                <FileTextIcon @click="navigateToPrescription(item.opNo,item.typeId)" class="custom-class" style="color:#009696;cursor:pointer"></FileTextIcon>
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>-->

                            <div style="margin-top:2%" v-if="Medicallist.length">
                                <vs-pagination :total="totalRecord" v-model="currentx" @change="getMedicalHistory"></vs-pagination>
                            </div>
                            <div style="margin-top:2%" v-if="!Medicallist.length">
                                <div style="background-color:#8080803b;height:50px;">
                                    <div align="center" style="padding-top: 7px;font-size: 18px;">No Records Found</div>
                                </div>
                            </div>

                        </div>
                    </vs-tab>

                    <vs-tab label="BillDetails" icon-pack="feather" icon="icon-file-text" @click="getBillHistory">
                        <div class="tab-text">
                         
                                <table class="detailsTable  billsTable">
                                <thead>
                                    <tr>
                                    <th class="smallhead" style="width:18%">Bill Number</th>
                                    <th class="smallhead" style="width:20%;">Bill Date</th>
                                    <th class="smallhead" style="width:20%;">Amount</th>
                                    <th class="smallhead" style="width:25%;">Reference Type</th>
                                    <th class="smallhead" style="width:30%;">Reference Number</th>
                                    </tr>
                                </thead>
                                   <tbody>
                                <tr v-for="(item,index) in BillList" :key="index" @dblclick="navigateToBill(item.billId)">
                                <td class="mediumhead" style="width:18%;">{{item.billId}}</td>
                                <td class="mediumhead" style="width:20%;">{{formatDate(item.billDate)}}</td>
                                <td class="mediumhead" style="width:20%;">{{item.totalAmount}}</td>
                                <td class="mediumhead" style="width:25%;">{{item.typeName}}</td>
                                <td class="mediumhead" style="width:30%;">{{item.refNo}}</td>
                                    </tr>
                                </tbody>
                                  
                                </table>
                            </div>
                            <div style="margin-top:2%" v-if="BillList.length">
                                <vs-pagination :total="totalBillrecords" v-model="curPage" @change="getBillHistory"></vs-pagination>
                            </div>
                            <div style="margin-top:2%" v-if="!BillList.length">
                                <div style="background-color:#8080803b;height:50px;">
                                    <div align="center" style="padding-top: 7px;font-size: 18px;">No Records Found</div>
                                </div>
                            </div>

                        
                    </vs-tab>

                    <vs-tab label="LabResult" icon-pack="feather" icon="icon-plus-square" @click="getLabHistory">
                        <div class="tab-text">
                            <table class="detailsTable  billsTable">
                                <thead>
                                    <tr>
                                    <th class="smallhead" style="width:10%;">Sr Number</th>
                                     <th class="smallhead" style="width:10%;">Date</th>
                                    <th class="smallhead" style="width:15%">Document Name</th>
                                    <th class="smallhead" style="width:10%;">Note</th>
                                    <th class="smallhead" style="width:25%;">report</th>
                                   
                                   
                                    </tr>
                                </thead>
                                <tbody>
                                      <tr v-for="(item,index) in LabList" :key="index">
                                <td class="mediumhead" style="width:10%;">{{index+1}}</td>
                                <td class="mediumhead" style="width:10%;">{{item.reportDate}}</td>
                                <td class="mediumhead" style="width:15%;">{{item.documentName}}</td>
                                <td class="mediumhead" style="width:10%;">{{item.note}}</td>
                               
                                     <td class="mediumhead" style="width:10%;">
                               <span>
                                                <DownloadIcon class="custom-class" @click="downloadfile(item.reportId)" style="color:#009696;cursor:pointer"></DownloadIcon>
                                            </span>
                                </td>
                                    </tr>
                                </tbody>
                            </table>
                                   <!--<div v-for="(item,index) in LabList" v-bind:key="index">
                                <table class="detailsTable">
                                    <tr>

                                        <td class="detailsTd" style="width:18%;line-height:0.5">
                                            <p class="smallhead">Sr Number</p>
                                            <p class="mediumhead">{{index+1}}</p>

                                        </td>
                                        <td class="detailsTd" style="width:25%;line-height:0.5">
                                            <p class="smallhead">Date</p>
                                            <p class="mediumhead">{{item.reportDate}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:25%;line-height:0.5">
                                            <p class="smallhead">Document Name</p>
                                            <p class="mediumhead">{{item.documentName}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:30%;line-height:0.5">
                                            <p class="smallhead">Note</p>
                                            <p class="mediumhead">{{item.note}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:40%">
                                            <span>
                                                <DownloadIcon class="custom-class" @click="downloadfile(item.reportId)" style="color:#009696;cursor:pointer"></DownloadIcon>
                                            </span>
                                        </td>

                                    </tr>
                                </table>
                            </div>-->
                            <!--  <table class="detailsTable  billsTable">
                                <thead>
                                    <tr>
                                    <th class="smallhead" style="width:10%;">Date</th>
                                     <th class="smallhead" style="width:10%;">Bill No</th>
                                    <th class="smallhead" style="width:15%">Name</th>
                                    <th class="smallhead" style="width:10%;">Age</th>
                                    <th class="smallhead" style="width:15%;">Sex</th>
                                   
                                    <th class="smallhead" style="width:20%;">Result status</th>
                                        <th class="smallhead" style="width:10%;">Report </th>
                                    </tr>
                                </thead>
                                   <tbody>
                                <tr v-for="(item,index) in LabList" :key="index">
                                <td class="mediumhead" style="width:10%;">{{item.billDate}}</td>
                                <td class="mediumhead" style="width:10%;">{{item.billNo}}</td>
                                <td class="mediumhead" style="width:15%;">{{item.patientName}}</td>
                                <td class="mediumhead" style="width:10%;">{{item.patientAge}}</td>
                                <td class="mediumhead" style="width:15%;">  {{ item.patientGender == 1 ? 'Male' : item.patientGender == 2 ? 'Female' : '-' }}</td>
                                 <td class="mediumhead" style="width:20%;">{{item.resultStatus}}</td>
                                     <td class="mediumhead" style="width:10%;">
                                <span>
                                    <FileTextIcon
                                    @click.stop=""
                                    
                                    style="color:#009696; cursor:pointer"
                                    />
                                </span>
                                </td>
                                    </tr>
                                </tbody>
                              </table>-->
                        
                            <div style="margin-top:2%" v-if="LabList.length">
                                <vs-pagination :total="totallabRecord" v-model="runPage" @change="getLabHistory"></vs-pagination>
                            </div>
                            <div style="margin-top:2%" v-if="!LabList.length">
                                <div style="background-color:#8080803b;height:50px;">
                                    <div align="center" style="padding-top: 7px;font-size: 18px;">No Records Found</div>
                                </div>
                            </div>

                        </div>
                    </vs-tab>


                    <!-- <vs-tab label="RoomDetails" icon-pack="feather" icon="icon-file-text" @click="getRoomHistory">
                        <div class="tab-text" >
                            <div v-for="(item,index) in RoomList" v-bind:key="index">
                                <table class="detailsTable">
                                    <tr>

                                        <td class="detailsTd" style="width:16%;line-height:0.5">
                                            <p class="smallhead">Room No</p>
                                            <p class="mediumhead">{{item.roomNo}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:25%;line-height:0.5">
                                            <p class="smallhead">Room Category</p>
                                            <p class="mediumhead">{{item.category}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:25%;line-height:0.5">
                                            <p class="smallhead">Booked Date</p>
                                            <p class="mediumhead">{{item.bookedDate}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:16%;line-height:0.5">
                                            <p class="smallhead">No of Days</p>
                                            <p class="mediumhead">{{item.noofDays}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:30%;line-height:0.5">
                                            <p class="smallhead">Released Date</p>
                                            <p class="mediumhead">{{item.releasedDate}}</p>
                                        </td>
                                        <td class="detailsTd" style="width:30%;line-height:0.5">
                                            <p class="smallhead">Action</p>
                                            <p class="mediumhead" style="cursor:pointer;color:green" @click="navigateToVacateorCahnge(item)">Change/Vacate</p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div style="margin-top:2%" v-if="RoomList.length">
                                <vs-pagination :total="totalRoomrecords" v-model="curPage" @change="getRoomHistory"></vs-pagination>
                            </div>
                            <div style="margin-top:2%" v-if="!RoomList.length">
                                <div style="background-color:#8080803b;height:50px;">
                                    <div align="center" style="padding-top: 7px;font-size: 18px;">No Records Found</div>
                                </div>
                            </div>

                        </div>
                    </vs-tab> -->


                </vs-tabs>
            </div>
        </vx-card>
    </div>

</div>
</template>

<script>
import {
    PhoneIcon,
    MailIcon,
    EditIcon,
    FileTextIcon,
    PlusSquareIcon,
    UserIcon,
    DownloadIcon,
    ClipboardIcon,
    FilePlusIcon,
    DollarSignIcon
} from 'vue-feather-icons'
export default {
    components: {
        PhoneIcon,
        MailIcon,
        EditIcon,
        FileTextIcon,
        PlusSquareIcon,
        UserIcon,
        DownloadIcon,
        ClipboardIcon,
        FilePlusIcon,
        DollarSignIcon
    },
    data() {
        return {
            Medicallist: [],
            BillList: [],
            LabList: [],
            RoomList:[],
            patientName: "Name",
            gender: "Sex",
            age: "Age",
            /*bloodGroup: "Bloodgroup",*/
            place:"Place",
            phoneNo: "PhoneNo",
            email: "Email",
            patientId: "",
            currentx: 1,
            limit: 4,
            curPage: 1,
            runPage: 1,
            totalRecord: '',
            show: "",
            dataItem: "",
            totalBillrecords: "",
            totallabRecord: "",
            totalRoomrecords:"",
            noofDays:""
        }
    },

    watch: {

        '$route'() {
            this.patientId = this.$route.query.patientId;
        },

    },

    created() {
        this.patientId = this.$route.query.patientId;
        this.$store.dispatch('updateBackOpFlag', false);
        this.getPatientDetails();
        this.getMedicalHistory();
    },
    // mounted(){
    //     this.$store.dispatch('updateBackOpFlag', false);
    // },
    methods: {
        navigateToPrescription(opId,refTypeId) {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                refId:opId,
                refTypeId:refTypeId
            };
                      this.$http.post("checkPrescriptionEntry", JSON.stringify(request), {
    headers: { "Content-Type": "application/json" }
  })
  .then(response => {
    const data = response.data.data;

    this.$router.push({
      path: 'prescription',
      query: {
        patientId: this.patientId,
        opId: opId,
        refType: refTypeId,
        status: data.status,
        prescriptionId: data.prescriptionId || null,
            from: 'patienttray'

      }
    });
  });
        },
           /*  this.$http.post(
                    "checkPrescriptionEntry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                if(response.data.data.status=="Y"){
                    this.$router.push({
                        path: 'prescriptionDashboard',
                         query: {
                                patientId: this.patientId,
                                opId: opId,
                                refType:refTypeId
                            }
                })
                }
                else{
                    this.$router.push({
                            path: 'prescription',
                            query: {
                                patientId: this.patientId,
                                opId: opId,
                                 refType:refTypeId
                            }
                    })
                }
                })*/
      
        exit() {
        if (this.$route.query.from === "opDashboard") {
    this.$router.push({ path: "/OpDashboardView" });
    }
    else{
          this.$router.push({
     path: '/patientDetailsDashboard' });
    }

},

        getPatientDetails: function () {
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };

            this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    console.log("patient tray",response.data.data)
                    if (response.data.data.name) this.patientName = response.data.data.name;
                    if (response.data.data.gender) this.gender = response.data.data.gender;
                    if (response.data.data.age) this.age = response.data.data.age;
                    /*if (response.data.data.bloodGroup) this.bloodGroup = response.data.data.bloodGroup;*/
                    if (response.data.data.phoneNo) this.phoneNo = response.data.data.phoneNo;
                    if (response.data.data.email) this.email = response.data.data.email;
                      if (response.data.data.place) this.place = response.data.data.place;
                })
        },
        getMedicalHistory: function () {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                currentPage: this.currentx,
                pageLimit: this.limit
            }
            this.$http.post(
                    "v2/getmedicalhistory",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    this.Medicallist = response.data.data;``
                    this.totalRecord = Math.ceil(response.data.recordsTotal / this.limit);
                })

        },
        getBillHistory: function () {
            var request = {
                companyId: this.$session.get('companyId'),
                attachedFlah: "N",
                patientId: this.patientId,
                currentPage: this.curPage,
                pageLimit: this.limit
            }

            this.$http.post(
                    "v2/getbillhistory",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    this.BillList = response.data.data;
                    this.totalBillrecords = Math.ceil(response.data.recordsTotal / this.limit);

                })
        },
          formatDate(date) {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  },
        getLabHistory: function () {
            console.log("phone no",this.phoneNo)
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                currentPage: this.runPage,
                pageLimit: this.limit,
                //phoneNo:this.phoneNo
            }

            this.$http.post(
                   // "testresultsdashboard",
                   "v2/getlabhistory",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    console.log("response ..8",response.data)
                    this.LabList = response.data.data;
                    this.totallabRecord = Math.ceil(response.data.recordsTotal / this.limit);
                    
                })
        },
        downloadfile(reportId) {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                reportId: reportId
            }

            this.$http.post(
                    "getlabreport",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    window.open(response.data.data.filePath);
                })
        },
       
        navigateToOp(opNo) {
            this.$router.push({
                path: 'opTicket',
                query: {
                    patientId: this.patientId,
                    opId: opNo
                }
            })
        },
          navigateToBill(billId) {
              //console.log("navigateToBill", "patientId:", this.patientId);
               this.$router.push({
        path: "billing",
        query: {
          billId:billId ,
          patientId:this.patientId,
           from: "patientTray"
        },
      });
        },

         getRoomHistory: function () {
            //  this.RoomList=[{"roomNo":"A0012","category":"A/C Classic","bookedDate":"2020-03-25",
            // "releasedDate":"","ipNo":"1","rate":"100"},
            //  {"roomNo":"A0015","category":"A/C Classic","bookedDate":"2020-03-12",
            // "releasedDate":"","ipNo":"1","rate":"200"}];


            //   this.RoomList.forEach((value,key) => {
                        
            //             const date1 = new Date(value.bookedDate);
            //             const date2 = new Date(new Date());
            //             const diffTime = Math.abs(date2 - date1);
            //             const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            //             this.RoomList[key].noofDays = diffDays;
            //         });
            //         console.log(this.RoomList);
            //  this.totalRoomrecords = Math.ceil(this.RoomList / this.limit);
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                currentPage: this.curPage,
                pageLimit: this.limit
            }

            this.$http.post(
                    "getBookedRoomDetails ",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                    this.RoomList = response.data.data.roomDetails;
                   
                    this.RoomList.forEach((value,key) => {
                        
                        const date1 = new Date(value.bookedDate);
                        const date2 = new Date(new Date());
                        const diffTime = Math.abs(date2 - date1);
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                        this.RoomList[key].noofDays = diffDays;
                    });
                    console.log(this.RoomList);
                    // this.totalRoomrecords = Math.ceil(response.data.recordsTotal / this.limit);

                })
        },
        navigateToVacateorCahnge(item){
            // console.log(item);
             const bookedRoomDetails={
                roomId: item.roomId,
                roomNo: item.roomNo,
                noofDays: item.noofDays,
                bookedDate: item.bookedDate,
                rate: item.rate
            }
            this.$store.dispatch('updateBookedRoomDetails', bookedRoomDetails);
             this.$router.push({
                path: 'roomChangeorVacate',
                query: {
                    patientId: this.patientId,
                    ipNo : 1
                }
            })
        }
    }

}
</script>

<style scoped>
.pBox {
    float: right;
}

.day__slot {
    width: 24px;
    padding: 4px;
    letter-spacing: normal;

}

.day__slot span {
    width: 24px;
    padding: 5px 0;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    font-size: 13px;
    color: #009696;
}

.day__slot span p {
    font-size: 11px;
}

.testTable {
    cursor: pointer;
}

.mediumhead {
    padding-top: 6px;
    padding-right: 6px;
    padding-bottom: 6px;
    padding-left: 6px;
    font-size: 12px;
    text-align: center;
    color: rgba(29, 31, 32, 0.57)
}

.detText {
    font-size: 12px;
    color: rgba(29, 31, 32, 0.57);
    padding-top: 7px;
}

.smallhead {
    padding-top: 6px;
    padding-right: 6px;
    padding-bottom: 6px;
    padding-left: 6px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: rgba(29, 31, 32, 0.57)
}

.bighead {
    font-size: 14px;
    font-weight: bold;
    color: rgba(29, 31, 32, 0.57);
}

.detailsTable {
    border-bottom: 1px solid #00000024;
    border-top: 1px solid #00000024;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 0.5%;
}
.billsTable {
  width: 100%;                 
  border-collapse: separate;   
  border-spacing: 0 6px;       
  margin-bottom: 0.5;
    border: none;  
}


.billsTable th {
  padding: 10px;
 
  border-bottom: 1px solid #00000024;
}


.billsTable td {
  padding: 10px;
 
  border-bottom: 1px solid #00000024; 
}

</style>
